export const NAVIGATION_ITEM_COLORS = {
  BLACK: 'black',
  FIRE: 'fire',
  ORCA: 'orca',
};

export const REQUEST_ID_STORE_KEY = 'req-id';
export const DEFAULT_REQUEST_TIMEOUT = 10000;
export const CORRELATION_ID_HEADER_KEY = 'correlation-id';
export const CORE_SITE_DOMAIN = 'https://www.afterpay.com';
